import { ModalToken } from "./types";

export function createModalToken<T>(description: string): ModalToken<T> {
    return description as ModalToken<T>;
}
